<ng-template #previewContentRef class="content"></ng-template>